/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'

import './Card.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

// import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate } from 'react-router-dom'

import { useSelector, useStore, useDispatch } from 'react-redux'
import { increaseItemAction, reduceItemAction, removeItemAction, emptyBasketAction } from '../../redux/store/Basket'
import { ToRial } from '../../services/money'

import PizzaBox from '../../assets/svg/Pizza.svg'

import trashIcon from '../../assets/svg/trash.svg'
import { notify } from '../../components/Toast'
import { get } from '../../services/https'
// import { post } from '../../services/https'

export default function index() {
  const navigate = useNavigate()
  const stores = useStore()
  const dispatch = useDispatch()

  const id = localStorage.getItem('shopId')
  const [items, setItems] = useState([])
  const [price, setPrice] = useState(0)
  const [shopsStatus, setShopStatus] = useState(false)

  const navigateHandler = () => {
    if (items.length === 0) {
      notify('error', 'سبد خرید شما خالی است')
    } else {
      navigate('/orderway')
    }
  }

  const basket = useSelector(state => state.basket)

  useEffect(() => {
    const store = stores.getState()
    setItems(store.basket)

    let itemPrice = 0
    let itemIds = []
    store.basket.map(item => {
      itemIds.push(item._id)
      itemPrice = itemPrice + item.allPrice
    })
    setPrice(itemPrice)

    get(`/api/front/shops/${id}`)
      .then(response => {
        response.data.data.map(item => {
          setShopStatus(item.status)
          if (item.status === false) {
            return Swal.fire({
              icon: "error",
              title: "رستوران تعطیل است",
              text: "",
              footer: '<a href="#">در صورت مشکل با پشتیبانی در تماس باشید</a>'
            })
          }
        })
      })

    get('/api/front/foods/all')
      .then(response => { 
        const selectFoods = []
        response.data.data.map(food => {
          if (itemIds.includes(food._id)) {
            selectFoods.push(food)
          }
        })

        store.basket.map(storeFood => {
          selectFoods.map(food => {
            if (storeFood._id === food._id) {
              if (storeFood.price == food.price || storeFood.price == food.discountPrice) {
                
              } else {
                dispatch(reduceItemAction(food._id))
                const basketArray = []
                basket.map(item => {
                  return basketArray.push(item)
                })
                setItems(basketArray)
                notify('error', `آیتم ${storeFood.name} به دلیل مغایرت قیمت از سبد خرید حذف شد`)
              }
            }
          })
        })
      })

  }, [basket, dispatch, id, stores])

  const increaseItemHandler = (e) => {
    dispatch(increaseItemAction(e.target.id))
    const basketArray = []
    basket.map(item => {
      return basketArray.push(item)
    })
    setItems(basketArray)
  }

  const reduceItemHandler = (e) => {
    dispatch(reduceItemAction(e.target.id))
    const basketArray = []
    basket.map(item => {
      return basketArray.push(item)
    })
    setItems(basketArray)
  }

  const removeItemHandler = (e) => {
    dispatch(removeItemAction(e.target.id))
    const basketArray = []
    basket.map(item => {
      return basketArray.push(item)
    })
    setItems(basketArray)
  }

  const emptyBasketHandler = (e) => {
    dispatch(emptyBasketAction())
    const basketArray = []
    basket.map(item => {
      return basketArray.push(item)
    })
    setItems(basketArray)
  }

  return (
    <div id='card'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
        <div className="row">
          <div className='cardTitle'>سبد خرید</div>
          <div className='emptyBasketStyle'>
            <img src={trashIcon} alt="trashIcon" onClick={emptyBasketHandler} />
          </div>
        </div>
        { items ? items.map((item, index) => (
          <div className='foodItem' key={index}>
            <div className='foodItemTitle'>{item.name}</div>
            <div className='details'>
              <span>{ToRial(String(item.price))} تومان</span>
              <span className='detailsCount'>
                <span className='down' id={item._id} onClick={item.count === 1 ? removeItemHandler : reduceItemHandler}></span>
                <span className='count'>{item.count}</span>
                <span className='add' id={item._id} onClick={increaseItemHandler}></span>
              </span>
              <span>{ToRial(String(item.allPrice))} تومان</span>
            </div>
            <div className='trashIcon'>
              <img src={trashIcon} id={item._id} alt="trashIcon" onClick={removeItemHandler} />
            </div>
          </div>
        )) : ' سبد خرید شما خالی است ' }

        { items.length === 0 ? 
          (
            <div className='emptyBasket'>
              <img src={PizzaBox} alt='pizza' />
              سبد خرید شما خالی است
            </div>
          ) : '' }
        <hr className='cardLine' />
        <div className='cardPrice'>
          <span>هـزینه کل :</span>
          <span>{ToRial(String(price))} تومان</span>
        </div>
        <div className='countinueButton'>
          <button onClick={navigateHandler} style={shopsStatus ? { display: '' } : { display: 'none' }}>تکمیل فرآیند خرید</button>
        </div>
      </div>
      <Footer page={'card'} />
    </div>
  )
}
